// extracted by mini-css-extract-plugin
module.exports = {"error":"render_error__nt0ra","spacer":"render_spacer__4afSa"};